import { createContext } from "react";
export const houseContext = createContext({});
